var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('z-stance',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStance),expression:"showStance"}],attrs:{"show-info":false,"descText":_vm.stanceInfo,"btn-text":"点击重试"},on:{"click":_vm.checkBizLicenseInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }